import {
  AccountBalanceWallet,
  ContentCopy,
  People,
  AccountCircle as PersonIcon,
  Share
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { axiosInstance } from "src/api/axios";
import image from '../../assets/images/backgrounds/refer.png';
const ReferralPage = () => {
  const [user, setUser] = useState({
    name: '',
    personalReferralCode: '',
    id: '',
  });

  const [refs, setRefs] = useState({
    userJoined: [],
    transactions: [],
    earned: 0,
  });

  useEffect(() => {
    let store = localStorage.getItem("store");
    if (store) {
      store = JSON.parse(store);
      setUser({
        name: store.user.name,
        personalReferralCode: store.user.personalReferralCode,
        id: store.user.id,
      });
      axiosInstance
        .get(`/users/referral/${store.user.id}`)
        .then((response) => {
          if (response?.data) {
            let earned = 0;
            if (response.data.transactions?.length) {
              earned = response.data.transactions.reduce(
                (sum, item) => (sum += item?.earned || 0),
                0
              );
            }
            setRefs({ ...response.data, earned });
          }
        })
        .catch(() => {
          setRefs({
            userJoined: [],
            transactions: [],
            earned: 0,
          });
        });
    }
  }, []);

  const handleShareReferral = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Join using my referral code',
          text: `Use my referral code: ${user?.personalReferralCode}`,
          url: window.location.href
        });
      } else {
        copyToClipboard();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(user?.personalReferralCode);
    alert('Referral code copied!');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'white' }}>
      {/* Header */}
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        px: 2,
        py: 1.5
      }}>
        <Typography variant="h6" fontWeight={600} sx={{ ml: 2 }}>
          REFER & EARN
        </Typography>
      </Box>

      {/* Content */}
      <Container maxWidth="md" sx={{ pb: 3 }}>
        {/* Refer Image Section */}
        <Box
          sx={{
            mt: 2,
            height: 170,
            borderRadius: 3,
            background: `url(${image}) no-repeat center/cover`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',

          }}
        >
        
        </Box>

        {/* Referral Code */}
        <Box sx={{ my: 3 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 1.5 }}>
            Your referral code
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              border: '2px dashed',
              borderColor: 'divider',
              borderRadius: 1,
              p: 2
            }}
          >
            <Typography variant="h5" fontWeight="bold" letterSpacing={2}>
              {user?.personalReferralCode}
            </Typography>
            <IconButton onClick={copyToClipboard} size="small">
              <ContentCopy />
            </IconButton>
          </Box>
        </Box>

        {/* Share Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleShareReferral}
          startIcon={<Share />}
          sx={{
            bgcolor: '#4CAF50',
            py: 1.5,
            borderRadius: 25,
            my: 3,
            '&:hover': {
              bgcolor: '#45a049'
            }
          }}
        >
          Share Referral Link
        </Button>

        {/* Links */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          my: 3
        }}>
          <Typography
            component="a"
            href="#"
            sx={{
              color: 'text.secondary',
              textDecoration: 'underline',
              fontSize: '0.875rem'
            }}
          >
            Terms & Condition
          </Typography>
          <Typography
            component="a"
            href="#"
            sx={{
              color: 'text.secondary',
              textDecoration: 'underline',
              fontSize: '0.875rem'
            }}
          >
            See how its worked
          </Typography>
        </Box>

        {/* Stats */}
        <Grid container spacing={2} sx={{ my: 3 }}>
          <Grid item xs={6}>
            <Card variant="outlined" sx={{ border: 2, borderColor: 'divider' }}>
              <CardContent sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <People sx={{ fontSize: 24, color: '#4285F4', mt: 1 }} />
                <Box sx={{ flex: 1, textAlign: 'center' }}>
                  <Typography fontSize={14} fontWeight={700}>
                    Total Referral
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" sx={{ mt: 1 }}>
                    {refs?.userJoined?.length < 10 && refs?.userJoined.length > 0
                      ? `0${refs?.userJoined.length}`
                      : refs?.userJoined.length}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card variant="outlined" sx={{ border: 2, borderColor: 'divider' }}>
              <CardContent sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <AccountBalanceWallet sx={{ fontSize: 24, color: '#34A853', mt: 1 }} />
                <Box sx={{ flex: 1, textAlign: 'center' }}>
                  <Typography fontSize={14} fontWeight={700}>
                    Referral Income
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" color="#4CAF50" sx={{ mt: 1 }}>
                    ₹{refs.earned}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Referrals List */}
        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" fontWeight={600} textAlign="center" sx={{ mb: 2 }}>
            Your Referrals
          </Typography>

          {refs?.transactions.length ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {refs.transactions.map((entry, index) => (
                <Card key={index} variant="outlined">
                  <CardContent sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 1.5,
                    '&:last-child': { pb: 1.5 }
                  }}>
                    <Avatar sx={{ width: 40, height: 40, bgcolor: 'transparent' }}>
                      <PersonIcon sx={{ fontSize: 40, color: '#B8860B' }} />
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1" fontWeight={600}>
                        {entry?.userName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        +91 {entry?.userNumber}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Earnings: ₹{entry?.principalAmount}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(entry?.datePaid).toLocaleDateString()}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="caption" color="text.secondary">
                        Earned
                      </Typography>
                      <Typography variant="body1" fontWeight="bold" color="#4CAF50">
                        ₹{entry?.earned}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              py: 2
            }}>
              <Typography variant="body2">No Transactions Found</Typography>
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default ReferralPage;